
import React from "react";

const OpportunitiesHeader: React.FC = () => {
  return (
    <div className="mb-8">
      <h1 className="text-3xl font-bold mb-2">Discover Opportunities</h1>
      <p className="text-muted-foreground max-w-2xl">
        Find internships, volunteer positions, competitions, and other opportunities to grow your skills.
      </p>
    </div>
  );
};

export default OpportunitiesHeader;
